module.exports = __webpack_public_path__ + "img/90501208vi.5f272d23.png";